import { NavLink } from "react-router-dom";
import { useVendorDirectoryPaths } from "../../../hooks/useVendorDirectoryPaths";
import { useVendorDirectoryPermissions } from "../../../hooks/useVendorDirectoryPermissions";
import {
  VENDOR_DIRECTORY_PERMISSIONS as P,
  hasVendorDirectoryPermission,
} from "../../../auth/casamapaVendorDirectoryPermissions";
import { useLocale } from "../../../intl";

const PIPELINE = "realEstate.casaMapa.admin.vendors.pipeline";

export default function ClientVendorDirectorySubnav({ clientViewId: _clientViewId }) {
  const { serviciosBase, isPartnerPortal, isScopedWorkspace } = useVendorDirectoryPaths();
  const { permissions } = useVendorDirectoryPermissions();
  const { t } = useLocale();
  const base = serviciosBase;

  if (isPartnerPortal || isScopedWorkspace) {
    return null;
  }

  const items = [
    { to: `${base}/proveedores`, label: t(`${PIPELINE}.allVendors`), permission: P.VENDORS_VIEW },
    { to: `${base}/candidatos`, label: t(`${PIPELINE}.candidates`), permission: P.CANDIDATES_VIEW },
    { to: `${base}/importaciones`, label: t(`${PIPELINE}.imports`), permission: P.IMPORTS_VIEW },
    { to: `${base}/duplicados`, label: t(`${PIPELINE}.duplicates`), permission: P.DUPLICATES_VIEW },
    { to: `${base}/resolucion`, label: t(`${PIPELINE}.resolution`), permission: P.RESOLUTION_VIEW },
    { to: `${base}/verificacion`, label: t(`${PIPELINE}.verification`), permission: P.VERIFICATION_VIEW },
    { to: `${base}/credenciales`, label: t(`${PIPELINE}.credentials`), permission: P.CREDENTIALS_VIEW },
    { to: `${base}/privacidad`, label: t(`${PIPELINE}.privacy`), permission: P.PRIVACY_REQUESTS_VIEW },
    { to: `${base}/reclamaciones`, label: t(`${PIPELINE}.claims`), permission: P.CLAIMS_VIEW },
    { to: `${base}/posicionamiento`, label: t(`${PIPELINE}.ranking`), permission: P.RANKING_VIEW },
    { to: `${base}/analytics`, label: t(`${PIPELINE}.analytics`), permission: P.ANALYTICS_VIEW },
    { to: `${base}/mantenimiento`, label: t(`${PIPELINE}.maintenance`), permission: P.MAINTENANCE_VIEW },
    { to: `${base}/piloto`, label: t(`${PIPELINE}.pilot`), permission: P.PILOT_VIEW },
    { to: `${base}/expansion`, label: t(`${PIPELINE}.expansion`), permission: P.EXPANSION_VIEW },
    { to: `${base}/marketplace`, label: t(`${PIPELINE}.marketplace`), permission: P.MARKETPLACE_VIEW },
    { to: `${base}/configuracion`, label: t(`${PIPELINE}.settings`), permission: P.SETTINGS_VIEW },
    { to: `${base}/fuentes`, label: t(`${PIPELINE}.sources`), permission: P.SOURCES_VIEW },
  ].filter((item) => hasVendorDirectoryPermission(permissions, item.permission));

  if (items.length <= 1) {
    return null;
  }

  return (
    <nav className="cvd-tabs" aria-label={t("realEstate.casaMapa.admin.vendors.directory.title")}>
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) => `cvd-tab${isActive ? " cvd-tab--active" : ""}`}
          aria-current={undefined}
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}
